var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TweenLite, TweenMax } from 'gsap/all';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import { ActivityManagerTyped as ActivityManager } from 'mixins/ActivityManager';
import DoneButton from '../components/activity/DoneButton.vue';
import DynamicContent from '../components/activity/DynamicContent.vue';
import Dropdown from '../components/activity/PickTheAnswerDropdown.vue';
import HtmlRenderer from '../components/activity/HtmlRenderer.vue';
import ActivityNextSectionPortal from '../components/activity/ActivityNextSectionPortal.vue';
import ActivityWrapper from '../components/activity/ActivityWrapper.vue';
import { Fragment } from 'vue-fragment';
import mixins from 'vue-typed-mixins';
const HINT = 'HINT';
const INCORRECT_ATTEMPT = 'INCORRECT_ATTEMPT';
export default mixins(AssetLoader, ActivityManager(), TypingActivityHelper, ErrorLogger).extend({
    name: 'PickTheAnswer',
    components: {
        DoneButton,
        DynamicContent,
        Dropdown,
        HtmlRenderer,
        ActivityNextSectionPortal,
        Fragment,
        ActivityWrapper
    },
    data() {
        return {
            correctGuesses: [],
            numOfAttempts: 0,
            selectedAnswers: [],
            displayWrongIcon: false,
            displayCorrectIcon: false
        };
    },
    watch: {
        currentRound() {
            let sentenceArray = [];
            const currentRound = this.currentRound;
            if (currentRound && currentRound.sentences) {
                currentRound.sentences.forEach(sentence => {
                    let answerArray = [];
                    if (sentence.fragments) {
                        sentence.fragments.forEach(fragment => {
                            if (fragment.answers) {
                                answerArray.push(null);
                            }
                            else {
                                answerArray.push({ correct: true, answer: {} });
                            }
                        });
                    }
                    sentenceArray.push(answerArray);
                });
            }
            this.selectedAnswers = sentenceArray;
        },
        numOfAttempts() {
            if (this.numOfAttempts >= 2 && this.correctGuesses.flat(1).includes(null))
                TweenLite.delayedCall(1.5, () => {
                    this.playAudio(HINT);
                });
        }
    },
    methods: {
        onDropDownSelect({ sentenceIndex, dropdownIndex, option }) {
            this.selectedAnswers[sentenceIndex][dropdownIndex] = option;
        },
        getActivityState() {
            const { rounds, incorrectAttempt } = this.activityData;
            return {
                rounds,
                hint: rounds[0].hint,
                incorrectAttempt,
                instructions: {
                    voice: rounds[0].instructions.audio.src,
                    delay: 0
                }
            };
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                const roundSetup = this.getActivityState();
                this.createRounds(roundSetup);
                const audiosMap = {
                    [HINT]: roundSetup.hint.audio.src,
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttempt.audio.src
                };
                this.sfx = yield this.loadAAAudios(audiosMap);
            });
        },
        startActivity() {
            this.setRound();
        },
        setRound() {
            this.setupNewRound();
            this.errorLoggerStart();
            this.$nextTick(() => {
                TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
            });
        },
        handleOnActivitySubmit() {
            if (this.displayCorrectIcon) {
                return;
            }
            this.incrementNumberOfAttempts();
            this.numOfAttempts = this.numOfAttempts + 1;
            const correctGuesses = this.selectedAnswers.map(answerArray => answerArray.map(answer => (answer && answer.correct ? answer : null)));
            this.correctGuesses = correctGuesses;
            if (correctGuesses.flat(1).includes(null)) {
                if (this.numOfAttempts < 2) {
                    this.playAudio(INCORRECT_ATTEMPT);
                }
                this.displayWrongIcon = true;
                TweenLite.delayedCall(1.5, () => {
                    this.displayWrongIcon = false;
                });
                return;
            }
            this.displayCorrectIcon = true;
            TweenLite.delayedCall(1.5, () => {
                this.processEndOfActivity();
            });
        }
    }
});
